import {  faHospitalUser } from '@fortawesome/free-solid-svg-icons'
import { faMemoCircleCheck, faFolderOpen} from "@fortawesome/pro-solid-svg-icons"

export const AdminNavigation = [
  { name: 'Caregivers', href: '/admins/caregivers', icon: faHospitalUser },
  { name: 'All Completed Consults & Referrals', href: '/admins/completed', icon: faMemoCircleCheck },
  { name: 'All Pending Consults & Referrals', href: '/admins/pending', icon: faFolderOpen },
]

